// Per-session advisor access key (private-trial rollout).
//
// A shared link carries ?key=<secret>. We keep it in sessionStorage — NOT
// localStorage and NOT the account — so access lasts exactly as long as the
// browser session that opened the link. Every advisor API call sends it via
// the X-Advisor-Key header; the backend validates per request.

const STORAGE_KEY = "vinuage_advisor_key";

export function getAdvisorKey() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || "";
  } catch (e) {
    return "";
  }
}

export function storeAdvisorKey(value) {
  try {
    if (value) sessionStorage.setItem(STORAGE_KEY, value);
  } catch (e) {
    // Private-mode storage failures degrade to key-in-URL-only access.
  }
}

export function advisorKeyHeaders() {
  const k = getAdvisorKey();
  return k ? { "X-Advisor-Key": k } : {};
}

// Reads ?key= from a location.search string, persists it for the session,
// and reports whether one was captured (callers then scrub the URL).
export function captureAdvisorKey(search) {
  const key = new URLSearchParams(search || "").get("key");
  if (key) storeAdvisorKey(key);
  return !!key;
}
